import style from '../../../LibraryView.scss';
import GuideMarkdownDisplay from '../../../../Layout/GuideMarkdownDisplay';
import * as React from 'react';

export const GuideMarkdown = ({ mdFile, prefix }) => (
  <div className={style.sectionWrapper}>
    <GuideMarkdownDisplay prefix={prefix} mdFile={mdFile} />
  </div>
);
